export enum WorkflowStatusType {
  Pending = 1,
  FeedProcessing = 2,
  FeedFailure = 3,
  ManualReviewPending = 4,
  Completed = 5,
  NeedsInfo = 6,
  InProgress = 7,
}
